/**
 * 화면설정 미리보기 (/adm/theme)
 * ($j.Pages.Admin.Theme / body data-page-name="Theme")
 *
 * 값을 저장하거나 판정하지 않는다 — 전부 `$j.F.Admin.Theme`(전역 스위치)에 위임하고,
 * 이 모듈은 **지금 걸린 값을 화면에 되비추는 일**만 한다.
 * 축이 늘면 여기가 아니라 F/Admin/Theme.js 와 App\Common\ThemeBoot 를 먼저 고친다.
 *
 */
export default class Theme {
    initialize() {
        // 견본(사이드바·탭·페이지네이션·드롭다운)의 링크는 모양만 보여준다 — 누르면 이동하지 않는다
        $('.th-wrap').on('click', 'a[href="#"]', (e) => e.preventDefault());
        this.T = $j.F.Admin.Theme;

        $('#thTheme').on('click', 'button', (e) => this._set('setTheme', e.currentTarget.dataset.theme));
        $('#thFs').on('click',    'button', (e) => this._set('setFontSize', e.currentTarget.dataset.fs));
        $('#thUi').on('click', 'button', (e) => this._set('setUi', e.currentTarget.dataset.ui));
        $('#thModalBtn').on('click', () => this._openModal());

        this.render();
    }

    /** 축 하나를 바꾸고 화면을 되비춘다 */
    _set(method, value) {
        this.T[method](value);
        this.render();
    }

    /**
     * 모달 미리보기 — JBModal 껍데기를 실제로 띄운다.
     *
     * `--ui-modal-*` 훅은 `<html>` 이 아니라 **모달 엘리먼트**에 걸려서 위 치수표(문서 루트를
     * 읽는다)로는 안 보인다. 그래서 띄운 뒤 그 엘리먼트에서 읽어 아래 표를 채운다.
     * 내용은 관리자 모달에 흔한 것들(안내문·폼·버튼)로 둔다 — 여백·반경이 어떻게 보이는지가 요점이다.
     */
    _openModal() {
        const body = `
            <p style="margin:0 0 12px">테마에 따라 <b>모서리·그림자·여백</b>이 달라집니다.</p>
            <div class="form-group"><label>사유</label>
                <input type="text" class="form-control" placeholder="예: 중복 접수"></div>
            <table class="table table-bordered table-sm" style="margin-bottom:12px">
                <thead><tr><th>항목</th><th>값</th></tr></thead>
                <tbody><tr><td>오더번호</td><td>497567</td></tr><tr><td>상태</td><td>배차완료</td></tr></tbody>
            </table>
            <div class="text-right"><button type="button" class="btn btn-default btn-sm mr-1">취소</button>
                <button type="button" class="btn btn-primary btn-sm">저장</button></div>`;
        $j.Ui.JBModal.html('theme-modal-preview', body, '모달 미리보기', { width: '520px' });

        // 띄운 직후 한 프레임 뒤에 읽는다 — 엔진이 클래스를 붙이고 나야 훅이 정해진다
        requestAnimationFrame(() => {
            const el = document.querySelector('#theme-modal-preview')?.closest('.ui-modal')
                    || document.querySelector('.ui-modal');
            const $t = $('#thModalMetrics');
            if (!el) { $('#thModalHint').text('모달을 찾지 못했습니다.'); return; }
            const cs = getComputedStyle(el);
            $t.prop('hidden', false).find('tbody tr').each((i, tr) => {
                const name = $(tr).find('code').text().trim();
                $(tr).find('.mv').text(cs.getPropertyValue(name).trim() || '—');
            });
        });
    }

    /**
     * 치수 토큰의 **계산된 값**을 표에 채운다.
     * 값을 JS 에 적어 두면 sass 와 어긋나므로 언제나 실제 CSS 에서 읽는다.
     */
    _readMetrics() {
        const cs = getComputedStyle(document.documentElement);
        $('#thMetrics tbody tr').each((i, tr) => {
            const name = $(tr).find('code').text().trim();
            $(tr).find('.mv').text(cs.getPropertyValue(name).trim() || '—');
        });
    }

    /** 지금 걸린 값을 버튼·표·요약뱃지에 되비춘다 */
    render() {
        const t = this.T.getPref();
        const f = this.T.getFontSizePref();
        const u = this.T.getUiPref();

        const on = ($scope, attr, val) => $scope.find('button').each((i, b) => {
            $(b).toggleClass('btn-primary', b.dataset[attr] === val)
                .toggleClass('btn-default', b.dataset[attr] !== val);
        });
        on($('#thTheme'), 'theme', t);
        on($('#thFs'),    'fs',    f);
        on($('#thUi'), 'ui', u);
        this._readMetrics();

        $('#thCurrent').text(`${t} · ${f} · ${u}`);
    }
}
